<template>
    <div style="width: 180px; display: flex;">
        <el-date-picker
            width="50%"
            v-model="value.start"
            :type="item.controlType === 6 ? 'date' : 'month'"
            placeholder="选择日期"
            :picker-options="{disabledDate: (time) => disabledDate(item, time)}"
            :value-format="item.controlType === 6 ? 'yyyy-MM-dd' : 'MM'"
        >
        </el-date-picker>
        <el-date-picker
            width="50%"
            v-model="value.end"
            :type="item.controlType === 6 ? 'date' : 'month'"
            placeholder="选择日期"
            :picker-options="{disabledDate: (time) => disabledDate(item, time)}"
            :value-format="item.controlType === 6 ? 'yyyy-MM-dd' : 'MM'"
        >
        </el-date-picker>
    </div>
</template>

<script>
export default {
    name: 'properties-date-range',
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        item: {
            type: Object,
            default() {
                return {}
            }
        },
        value: {
            type: Object,
            default() {
                return {
                    start: '',
                    end: ''
                }
            }
        },
        disabledDate: {
            type: Function
        }
    },
    watch: {
        value: {
            handler(val) {
                this.$emit('change', val);
            },
            deep: true
        }
        
    },
    methods: {
    }
}
</script>

<style lang="scss">
</style>